import {Directive, ElementRef, EventEmitter, OnDestroy, Output} from '@angular/core';

@Directive({
  selector: '[ngChange]'
})

export class NgChangeDirective implements OnDestroy {

  private readonly changes: MutationObserver;

  @Output()
  public ngChange: EventEmitter<any> = new EventEmitter();

  constructor(private readonly  elementRef: ElementRef) {

    const element = this.elementRef.nativeElement;

    this.changes = new MutationObserver((mutations: MutationRecord[]) => {
      for(const mutation of mutations){
        this.ngChange.emit(mutation)
      }
      }
    );

    this.changes.observe(element, {
      attributes: true,
      childList: true,
      characterData: true
    });
  }

  ngOnDestroy(): void {
    this.changes.disconnect();
  }
}
